import {api} from "@/store/api";
import Tracking from "@/model/Tracking";

export default {
  state: {
    event: null,
    product: null,
    productType: null,
    productReference: null,
    productId: null
  },
  getters: {
    getEventProduct: (state) => {
      return state.product
    },

    getReferrer: (state) => {
      if (document.referrer !== '') {
        return document.referrer;
      } else {
        return document.baseURI
      }
    },
  },
  mutations: {

  },
  actions: {
    productTracking({dispatch, commit, state}, payload) {
      let page = payload.page;
      let product = payload.product;

      switch (page) {
        case 'home-design':
          state.productId = product.cpidstring;
          state.productReference = {
            design: product.designproductname,
            plan: product.productname
          };
          state.event = 'View Home Design on page';
          state.productType = 'Home Design';
          break;
        case 'elevation':
          state.productId = product.productid;
          state.productReference = product.productname;
          state.event = 'Select Elevation';
          state.productType = 'Elevation';
          break;
        case 'hnl-package':
          state.productId = product.cpidstring;
          state.productReference = product.productname;
          state.event = 'View Package on page';
          state.productType = 'Package';
          break;
        case 'brochure':
          state.productId = product.cpidstring;
          state.productReference = product.productname;
          state.event = 'Downloaded Brochure on page';
          state.productType = 'Brochure';
          break;
        case 'documents-library':
          state.productId = product.cpidstring;
          state.productReference = product.productname;
          state.event = 'View Documents Library on Page';
          state.productType = product.producttype;
          break;
        case 'download':
          state.productId = product.productId;
          state.productReference = {
            DocumentType: product.type,
            DocumentSubType: product.subType,
            DocumentShortDescription: product.productName + ' Package PDF',
            DocumentFilename: product.productName + '.pdf',
            BuilderName: product.builderName,
          };
          state.event = product.event;
          state.productType = product.producttype;
          break;
        case 'contact':
          state.productId = product.productid;
          state.productReference = product.contactid;
          state.event = 'Submitted Contact on Page';
          state.productType = 'Contact';
          break;
        case 'lot-click':
          state.productId = product.productId;
          state.productReference = {
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.productName,
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'handl-click':
          state.productId = product.productId;
          state.productReference = {
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Builder: product.builderName,
            Plan: product.productName,
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'home-click':
          state.productId = product.productId;
          state.productReference = {
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.productName,
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'poi-click':
          state.productReference = {
            Name: product.productName,
            Category: product.category,
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'enquiry-submit':
          state.productId = product.productId;
          state.productReference = {
            FirstName: product.firstName,
            LastName: product.lastName,
            Mobile: product.mobile,
            Email: product.email,
            productId: product.shortListedProducts,
            productCount: product.productCount,
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'create-package':
          state.productId = product.productId;
          state.productReference = {
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.planProductName,
            Facade: product.productName,
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        default:
          state.event = 'Page View';
          state.productType = null;
          state.productId = null;
          break;
      }

      if (sessionStorage.getItem('trackerid')) {
        dispatch('eventTracking')
      }
    },

    checkSession({dispatch, commit, state, getters}, payload) {
      state.event = payload.event;
      state.productReference = payload.productreference;
      state.productId = payload.productid;
      state.productType = payload.producttype;
      if (!sessionStorage.getItem('trackerid')) {
        dispatch('initiateTracking')
      } else {
        dispatch('eventTracking')
      }
    },

    initiateTracking({dispatch, commit, state, getters}, payload) {
      const trackingItems = Tracking;
      return FingerprintJS.load().then((fp) => {
        fp.get().then(result => {
          trackingItems.fingerprint = result.visitorId;
          trackingItems.request_type = 'initiate_tracker';
          trackingItems.capsuleid = process.env.CAPSULEID;
          trackingItems.referrer = getters.getReferrer;
          trackingItems.trackersource = window.location.href;
          trackingItems.trackeragent = navigator.userAgent;
          trackingItems.trackermessage = 'Initiated tracker';

          api.postTracking('initiatetrackerlog', trackingItems).then(res => {
            if (res && res.data) {
              let response = JSON.parse(res.data);
              if (response.trackerid) {
                sessionStorage.setItem('trackerid', response.trackerid);
                dispatch('eventTracking');
                // this.eventTracking(event, reference, productId, productType);
              }
            }
          })
        })
      })
    },

    eventTracking({dispatch, commit, state, getters}, payload) {
      let eventItems = {
        request_type: 'initiate_tracker_event',
        trackerid: sessionStorage.getItem('trackerid'),
        productreference: state.productReference,
        capsuleid: process.env.CAPSULEID,
        productid: state.productId,
        producttype: state.productType,
        eventname: state.event
      }
      api.postTracking('publisheventlogtracker', eventItems).then((res) => {
        return res;
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/r6analytics.js